import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {IReelStartSpinData, IReelStopSpinData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ReelSymbolName} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolName";
import {ISymbolStateConfig, StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {SpinReelController} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelController";
import {Timeline, TimelineLite, TimelineMax, TweenLite} from "gsap";
import {TractorBeamHelper} from "../../utils/TractorBeamHelper";
import {TractorBeamRandFeatureEvent} from "../randomfeature/TractorBeamRandomFeatureController";
import {TractorBeamScatterReelSymbol} from "../reelsymbol/TractorBeamScatterReelSymbol";
import {TractorBeamParsedGameData} from "../server/data/TractorBeamParsedGameData";
import {TractorBeamParsedInitData} from "../server/data/TractorBeamParsedInitData";
import {BasicStateReelSymbol} from "../symbols/BasicStateReelSymbol";
import {TractorBeamGameConfig} from "../TractorBeamGameConfig";
import {TractorBeamGameModuleConfig} from "../TractorBeamGameModuleConfig";

interface ISlowAttentionSpinSymbolConfig {
    reelId:number;
    symName:string;
    startPosition:number;
    steps:number;
    spinSpeed:number;
    symbolState?:ISymbolStateConfig;
}

export class TractorBeamReelController extends SpinReelController {
    //Private/Protected properties
    private _slowDownAttententionSymbols:string[] = [];
    private _tractorBeamCurrentGameMode:string;
    private _tractorBeamNextGameMode:string;
    private _slowAttentionSymbolOccurence:number = 0;
    private _randomFeatureTriggered:boolean = false;
    private _randomFeatureStartPoistion:number = 1;
    protected _randomSymbols:ISlowAttentionSpinSymbolConfig[] = [];
    private _quickStop:boolean = false;
    private _initialLowSymbolSkip:boolean = false;

    private _tractorData:TractorBeamParsedGameData;
    private _randomStackedTriggered:boolean;
    private _randomStackedOverlayReels:boolean [];

    /**
     * Funtion to initialize reel strip for the first time when game loads.
     * Extending base class function to hide not required reel symbols upon initialization.
     */
    protected initReelStrip():void {
        this._currentFullReelSet = this._currentFullReelSet ? this._currentFullReelSet.concat() : [];
        if(this._tractorBeamCurrentGameMode === "FREESPIN" /*&& this._tractorBeamNextGameMode !== "NORMAL"*/) {
            this.updateReelSetRelativeToCommandCenter();
        }
        super.initReelStrip();
        if(this.allSymbols && this.allSymbols.length > 0) {
            const symbolAbove = this.findSymbol(-1);
            const symbolBelow = this.findSymbol(3);
            if(symbolAbove && symbolBelow) {
                symbolAbove.alpha = 0;
                symbolBelow.alpha = 0;
            }
        }
    }

    /**
     * Extending base class function to add event listeners.
     */
    protected addEventListeners():void {
        super.addEventListeners();
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));
        EventHandler.addEventListener(this, SpinEvent.BEFORE_START, (event:SpinEvent) => this.onBeforeSpinStart());
        EventHandler.addEventListener(this, TractorBeamRandFeatureEvent.SHUFFLE_CURRENT_REEL_SET, (event:GameEvent) => this.reshuffleNextReelSet(event.params[0]));
        EventHandler.addEventListener(this, TractorBeamRandFeatureEvent.RESET_REEL_SPEED, (event:GameEvent) => this.resetReelSpeed(event.params[0]));
        EventHandler.addEventListener(this, TractorBeamRandFeatureEvent.REMOVE_RANDOM_SYMBOL_TO_REEL, (event:GameEvent) => this.onRemoveSpinningRandomSymbol(event.params[0]));
        EventHandler.addEventListener(this, TractorBeamRandFeatureEvent.RANDOM_SYMBOL_POSITION, (event:GameEvent) => this.logRandomSymbolPosition(event.params[0]));
    }

    /**
     * Function to remove symbol config from slowDownAttententionSymbols list
     * @param reelId
     * @param symName
     */
    private onRemoveSpinningRandomSymbol(reelId:number):void {
        if(reelId != this._reelId) {
            return;
        }

        this._slowDownAttententionSymbols = [];
        this._initialLowSymbolSkip = false;
    }

    /**
     * Extending Base class function to reset class properties when spin completes.
     */
    protected completeSpin():void {
        this._randomSymbols = [];
        this._slowAttentionSymbolOccurence = 0;
        this._attentionSymbols = [];
        super.completeSpin();
    }

    // TODO: Break out to BeforeSpinTopController, render obsolete
    parseReelSetToInject(reelId:number):void {
        let reelSet:string [] = [];
        //const reel:string [] = TractorBeamGameConfig.instance.REEL_SETS.STACK_INJECTION_REELSET[reelId];

        //reelSet = this._stopReelSets[reelId]; // NO
        /*this._currentReelSet.length = 0;
        reel.forEach((symbol, sID) => {
            if(symbol === "R" && this._randomStackSymbol != null) {
                //this._currentReelSet.push(this._randomStackSymbol);
                reelSet.push(this._randomStackSymbol);
            }
        });*/

        /*this._nextReelSet.length = 0;
        reel.forEach((symbol, sID) => {
            if(symbol === "R" && this._randomStackSymbol != null) {
                this._nextReelSet.push(this._randomStackSymbol);
                reelSet.push(this._randomStackSymbol);
            }
        });*/

        //this._reelSetToInject = reelSet;
        //console.log(reel);
        //console.log("Injection ReelSet: " + reelSet);
    }

    public startSpin(data:IReelStartSpinData, previousDelay:number):number {
        [0, 1, 2, 3, 4].forEach((reelId:number) => {
            [0, 1, 2].forEach((symId:number) => {
                const symbol:BasicStateReelSymbol | null = <BasicStateReelSymbol>Reels.getSymbol(reelId, symId);
                if(symbol && ["M1", "M2", "M3", "M4", "L1", "L2", "L3", "L4", "W", "S"].indexOf(symbol.symName) > -1) {
                    if(symbol.symName === "S") {
                        new TimelineLite().add(() => {
                            if(symbol) {
                                symbol.playSpineAnimation(symbol.symName, symbol.symName + "-spinStart", false, 1);
                            }
                        }, 1);
                    } else {
                        symbol.playSpineAnimation(symbol.symName, symbol.symName + "-spinStart", false, 1);
                    }
                    //this.bounceSymbol(symbol);
                }
            });
        });

        return super.startSpin(data, previousDelay);
    }

    protected bounceSymbol(sym:StateReelSymbol, duration:number = 0.3):Timeline {
        const timeline:Timeline = new TimelineMax({paused : true});
        const time:number = duration / 5;

        timeline.add(TweenLite.to(sym.scale, time, {
            x : 1.1,
            y : .7
        }));

        timeline.add([
            TweenLite.to(sym.scale, time * 2, {x : 0.9, y : 1.1})
        ]);

        timeline.add([
            TweenLite.fromTo(sym.scale, time * 2, {
                x : 0.9,
                y : 1.1
            }, {
                x : 1,
                y : 1
            })
        ]);

        timeline.reverse();


        return timeline;
    }

    /**
     * Function to capture game data
     * @param data
     */
    public onGameDataParsed(data:TractorBeamParsedGameData):void {
        super.onGameDataParsed(data);

        this._tractorData = <TractorBeamParsedGameData>data;

        this._slowDownAttententionSymbols = [];
        for(let i = 0; i < data.removedSymbols.length; i++) {
            this._slowDownAttententionSymbols.push(data.removedSymbols[i]);
        }
        this._randomFeatureTriggered = data.isRandomFeature;
        this._randomStackedTriggered = data.randomStackedTriggered;
        this._tractorBeamCurrentGameMode = data.mode;
        this._tractorBeamNextGameMode = data.nextMode;
        this._randomStackedOverlayReels = data.randomStackedOverlayReels;


        // TODO: Break out to BeforeSpinTopController, could probably remove all this as it's now handle by beforeSpinStop-controller
        /*this._randomStackedOverlayReels = this._tractorData.randomStackedOverlayReels;
        this._randomStackedTriggered = this._tractorData.randomStackedTriggered;
        if(this._randomStackedTriggered) {
            const stackReelIndex = this._randomStackedOverlayReels.indexOf(true);
            const reels = data.reels;
            this._randomStackSymbol = reels[stackReelIndex][0];
            //this.parseReelSetToInject(this._reelId);
            //console.log("Stack Symbol STR-ID: " + this._randomStackSymbol);
            //this.parseReelSetToInject();
        } else {
            this._randomStackSymbol = null;
        }*/
    }

    /**
     * Function to capture init game data.
     * @param data
     */
    protected onInitDataParsed(data:TractorBeamParsedInitData):void {
        super.onInitDataParsed(data);
        this._slowDownAttententionSymbols = [];
        for(let i = 0; i < data.removedSymbols.length; i++) {
            this._slowDownAttententionSymbols.push(data.removedSymbols[i]);
        }
        this._tractorBeamCurrentGameMode = data.mode;
        this._tractorBeamNextGameMode = data.nextMode;
    }

    /**
     * Function to blur next symbol on reelset when slowAttentionSymbol lands on reel.
     * @param symbol
     */
    private blurNextReelSymbol(symbol:StateReelSymbol):void {
        symbol.changeState({
            state : GameConfig.instance.SYMBOL_STATES.noWin ? GameConfig.instance.SYMBOL_STATES.normal : GameConfig.instance.SYMBOL_STATES.normal,
            replay : false
        });
        (<TractorBeamScatterReelSymbol>symbol).playSpineAnimation((<TractorBeamScatterReelSymbol>symbol).symName, (<TractorBeamScatterReelSymbol>symbol).symName + "-spinEnd", false, 20);
    }

    /**
     * Extended base class function to avoid adding slowAttentionSymbol to reel set if already present.
     * @param symName
     * @param positions
     * @param state
     */
    protected addNewSymbol(symName:string, state?:ISymbolStateConfig, positions?:[number, number],):StateReelSymbol {
        if(this._randomFeatureTriggered && this._slowDownAttententionSymbols.length > 0) {
            let slowDownAttententionSymbols = this._slowDownAttententionSymbols;
            let indexArray:any[] = this._reelPartAnimator.symbolsToAnimate.map((e, i) => (slowDownAttententionSymbols.indexOf(e.symName) > -1 && i < 10) ? i : '').filter(String);
            if(!this._initialLowSymbolSkip) {
                if(slowDownAttententionSymbols.indexOf(symName) > -1 && indexArray.length > 0) {
                    do {
                        this._currentReelSetPosition--;
                        this._currentReelSetPosition = ArrayHelper.reviseIndexInLoopRange(this._currentReelSet.length, this._currentReelSetPosition);
                    } while(this._currentReelSet.map((e, i) => slowDownAttententionSymbols.indexOf(e) > -1 ? i : '').filter(String).indexOf(this._currentReelSetPosition) > -1);
                    symName = this._currentReelSet[this._currentReelSetPosition];
                } else if(indexArray.length === 0) {
                    TractorBeamHelper.shuffle(this._currentReelSet);
                    this._initialLowSymbolSkip = true;
                }
            } else {
                if(slowDownAttententionSymbols.indexOf(symName) > -1 && indexArray.length > 1) {
                    do {
                        this._currentReelSetPosition--;
                        this._currentReelSetPosition = ArrayHelper.reviseIndexInLoopRange(this._currentReelSet.length, this._currentReelSetPosition);
                    } while(this._currentReelSet.map((e, i) => slowDownAttententionSymbols.indexOf(e) > -1 ? i : '').filter(String).indexOf(this._currentReelSetPosition) > -1);
                    symName = this._currentReelSet[this._currentReelSetPosition];
                }
            }
        }

        if(this._isSpinBlurred) {
            state = GameConfig.instance.SYMBOL_STATES.spin;
        } else {
            state = state == undefined ? GameConfig.instance.SYMBOL_STATES.normal : state;
        }

        const symbol:StateReelSymbol = this._reelPartCreator.createNewSymbol(symName, this._reelId, state, {
            width : this._reelPartAnimator.symWidth,
            height : this._reelPartAnimator.symHeight,
            bottomPadding : this._reelPartAnimator.symBottomPadding
        });
        symbol.x = 0;
        symbol.y = -symbol.symHeight / 2 - GameConfig.instance.REEL_AREA_POS_Y - GameConfig.instance.REEL_DISPLAY_POSITIONS[this._reelId][1]; // this is just a temp position that's not visible. this position might be visible in portrait mode but it doens't matter.

        this._reelView.addChildAt(symbol, 0);

        return symbol;

        //return super.addNewSymbol(symName, state);
    }

    /**
     * Function lookup for slowAttentionSymbol on reelset if present and slow down the reels. Also blur out rest of the symbols.
     */
    private tryTractorBeamStartSlowSpinAttention():void {
        if(this._randomFeatureTriggered && this._slowDownAttententionSymbols.length > 0) {
            let slowDownAttententionSymbols = this._slowDownAttententionSymbols;
            if(this._symNumTop + this._randomFeatureStartPoistion < 0) {
                throw new Error("ReelController.tryStartSlowSpinAttention(), the start position is out of reel's range!");
            }
            const attentionSymbol:StateReelSymbol = this._reelPartAnimator.symbolsToAnimate[this._symNumTop + this._randomFeatureStartPoistion];
            if(slowDownAttententionSymbols.indexOf(attentionSymbol.symName) > -1 && this._initialLowSymbolSkip) {

                this._reelPartAnimator.symbolsToAnimate.forEach((sym:StateReelSymbol) => {
                    const symbol:BasicStateReelSymbol | null = <BasicStateReelSymbol>sym;

                    if(symbol && ["M1", "M2", "M3", "M4", "W"].indexOf(symbol.symName) > -1) {
                        symbol!.showNormalTexture();
                    }
                });

                //Blur remaining symbols to make slowAttentionSymbol stand out on reel.
                for(let i = 0; i < this._reelPartAnimator.symbolsToAnimate.length; i++) {

                    //(<TractorBeamScatterReelSymbol> this._reelPartAnimator.symbolsToAnimate[i])!.removeNoWinBlur();

                    (<TractorBeamScatterReelSymbol>this._reelPartAnimator.symbolsToAnimate[i])!.playSpineAnimation((<TractorBeamScatterReelSymbol>this._reelPartAnimator.symbolsToAnimate[i]).symName, (<TractorBeamScatterReelSymbol>this._reelPartAnimator.symbolsToAnimate[i]).symName + "-spinEnd", false);

                    /*this._reelPartAnimator.symbolsToAnimate[i].changeState({
                        state: GameConfig.instance.SYMBOL_STATES.normal,
                        replay: false,
                        fadeInDuration: 0.2,
                        fadeInDelay: 0
                    });*/


                    if(slowDownAttententionSymbols.indexOf(this._reelPartAnimator.symbolsToAnimate[i].symName) === -1) {
                        /*this._reelPartAnimator.symbolsToAnimate[i].changeState({
                            state: GameConfig.instance.SYMBOL_STATES.noWin ? GameConfig.instance.SYMBOL_STATES.noWin : GameConfig.instance.SYMBOL_STATES.normal,
                            replay: false,
                            fadeInDuration: 0.2,
                            fadeInDelay: 0
                        });*/
                    } else {
                        this._reelPartAnimator.symbolsToAnimate[i].changeState({
                            state : GameConfig.instance.SYMBOL_STATES.normal,
                            replay : false,
                            fadeInDuration : 0,
                            fadeInDelay : 0
                        });
                    }
                }
                this.updateCurrentReelSet(this.reelId);
                TractorBeamHelper.shuffle(this._currentReelSet);
                this.resetCurrentReelSpeed(this.reelId, 4);
                let stateTimeLine:TimelineLite = new TimelineLite({
                    onComplete : () => {
                        //EventHandler.dispatchEvent(new GameEvent(TractorBeamRandFeatureEvent.RANDOM_SYMBOL_LANDED))
                        stateTimeLine.pause();
                        stateTimeLine.kill();
                    }
                })
                stateTimeLine.add(attentionSymbol.changeState({
                    state : GameConfig.instance.SYMBOL_STATES.normal,
                    replay : false,
                    fadeInDuration : 0, //2 / 4,
                    fadeInDelay : 0
                }));
                this._reelView.addChild(attentionSymbol);
                return;
            }
        }
    }

    /**
     * Function to reset all reels speed
     * @param speed
     */
    private resetReelSpeed(speed:number):void {
        TweenLite.to(this._reelPartAnimator, 0, {spinSpeed : speed});
    }

    /**
     * Function to reset current reelSpeed.
     * @param reelId
     * @param speed
     */
    private resetCurrentReelSpeed(reelId:number, speed:number):void {
        if(reelId != this._reelId) {
            return;
        }

        TweenLite.to(this._reelPartAnimator, 0, {spinSpeed : speed});
    }

    /**
     * Extended base class function to add state check when setting next reel set.
     * @param stopReelSets
     * @param nextReelSetName
     */
    public getReadyToStop(stopReelSets:string[], nextReelSetName:string):number {
        this._stopReelSet = stopReelSets;
        if(!(this._tractorBeamCurrentGameMode === "FREESPIN" /*&& this._tractorBeamNextGameMode !== "NORMAL"*/)) {
            this._nextFullReelSet = Helper.getReelSet(nextReelSetName, this._reelId).concat();
        }

        // The stop offset is for features on the reel to prolong the stop.
        // The reelArea will take the biggest offset as the real stop offset.
        return this.getSpinStopOffset();
    }

    /**
     * Function to update reelSet as per removed symbols.
     */
    public updateReelSetRelativeToCommandCenter(clear:boolean = false):void {
        if(clear) {
            //this._slowDownAttententionSymbols = ["S"];

            /*[0, 1, 2, 3, 4].forEach((reelId:number) => {
                this._currentReelSet = Helper.getReelSet("BASE_REELSET", reelId).concat();
                this._nextFullReelSet = Helper.getReelSet("BASE_REELSET", reelId).concat();
            });*/
            //this._currentReelSet = Helper.getReelSet("BASE_REELSET", this._reelId).concat();
            //this._nextFullReelSet = Helper.getReelSet("BASE_REELSET", this._reelId).concat();
            //EventHandler.dispatchEvent(new GameEvent(ReelEvent.REEL_SET_CURRENT_REEL_SET, {reelSetName: "BASE_REELSET"}));
        }

        if(this._slowDownAttententionSymbols && this._slowDownAttententionSymbols.length > 0) {
            for(let i:number = 0; i < this._slowDownAttententionSymbols.length; i++) {
                for(let j:number = 0; j < TractorBeamGameConfig.instance.REELS_NUM; j++) {
                    this.updateReelSets(j, this._slowDownAttententionSymbols[i]);
                }
            }
        }
    }

    /**
     * Function called before spin starts. update reel set as per removed symbols.
     */
    private onBeforeSpinStart():void {
        this._randomSymbols = [];
        this._quickStop = false;
        this._slowAttentionSymbolOccurence = 0;
        TractorBeamGameModuleConfig.background.resetBeams();
        if(this._tractorBeamCurrentGameMode === "FREESPIN" /*&& this._tractorBeamNextGameMode !== "NORMAL"*/) {
            this.updateReelSetRelativeToCommandCenter();
        }
    }

    /**
     * Function to update reel set according to removed symbols.
     * @param reelId
     * @param symName
     */
    private updateReelSets(reelId:number, symName:string):void {
        this._currentFullReelSet = this._currentFullReelSet.filter((item, index) => {return item !== symName});
        this._currentReelSet = this._currentFullReelSet.concat();
        this._currentReelSetPosition = this.randomizeReelSetPosition(this._currentReelSet);
        this._nextFullReelSet = this._currentReelSet.concat();
    }

    // Get a position that the symbol is not part of a stacked symbol unless it's the bottom of the stacked symbol.
    protected randomizeReelSetPosition(reelSet:string[]):number {
        let position:number;
        do {
            position = MathHelper.randomNumberInRange(0, reelSet.length - 1);
        } while(StateReelSymbol.parseStackedSymbolName(reelSet[position], position).isStacked || position == 0);

        return position;
    }


    /*protected newRandomizeReelSetPosition(reelSet:string[]):number {
        let position:number;
        do {
            position = MathHelper.randomNumberInRange(0, reelSet.length - 1);

        } while(position < 5);

        const parsedStackedName:IParsedStackedSymbolName = StateReelSymbol.parseStackedSymbolName(reelSet[position]);
        if(parsedStackedName.isStacked) {
            position += parsedStackedName.totalNum - 1 - parsedStackedName.index;
        }

        return position;
    }*/

    /**
     * Function to remove duplicate enteries of slowAttentionsymbol and shuffle the reelset for all reels.
     * @param symName
     */
    private reshuffleNextReelSet(symName:string):void {
        let randomRange:number = this._quickStop ? 2 : this._currentFullReelSet.length / 2;
        if(!this._quickStop) {
            this.updateReelSets(this.reelId, symName);
        }
        TractorBeamHelper.shuffle(this._currentFullReelSet);
        this._currentFullReelSet.splice(Math.floor((Math.random() * randomRange)), 0, symName);
        this._currentReelSet = this._currentFullReelSet.concat();
        this._currentReelSetPosition = this.randomizeReelSetPosition(this._currentReelSet);
        this._nextFullReelSet = this._currentReelSet.concat();

        // Remove stacked Scatters
        /*this._nextFullReelSet.forEach((symName:string, index:number) => {
            if(symName === "S") {
                if (this._nextFullReelSet[index - 2] && this._nextFullReelSet[index - 2] === "S") {
                    this._nextFullReelSet[index - 2] = "W";
                    console.log("switched stacked scatter -2");
                }
                if (this._nextFullReelSet[index - 1] && this._nextFullReelSet[index - 1] === "S") {
                    this._nextFullReelSet[index - 1] = "M1";
                    console.log("switched stacked scatter -1")
                }
            }
        });*/

    }

    /**
     * Function to update current reelSet.
     * @param reelId
     * @param symName
     */
    private updateCurrentReelSet(reelId:number):void {
        if(reelId != this._reelId) {
            return;
        }
        for(let i = 0; i < this._slowDownAttententionSymbols.length; i++) {
            this.updateReelSets(reelId, this._slowDownAttententionSymbols[i]);
        }
    }

    /**
     * Extended base class function to notify and handle slowAttentionSymbol movements over reel.
     * @param symbolToRemove
     */
    protected onSpinStepCompleted():void {
        let slowDownAttententionSymbols:string[] = this._slowDownAttententionSymbols;
        let slowAttentionSymbol:StateReelSymbol[] = this._reelPartAnimator.symbolsToAnimate.filter(function(element) {
            return (element.currentState!.keyword === "normal" && slowDownAttententionSymbols.indexOf(element.symName) > -1);
        });

        if(slowAttentionSymbol.length > 0 && this._randomFeatureTriggered) {

            this._slowAttentionSymbolOccurence++;
            switch(this._slowAttentionSymbolOccurence) {
                case 1:
                    this.updateCurrentReelSet(this.reelId);
                    this._slowAttentionSymbolOccurence = 0;
                    EventHandler.dispatchEvent(new GameEvent(TractorBeamRandFeatureEvent.ADD_NEXT_SYMBOL, this.reelId, slowAttentionSymbol[0].symName, this._quickStop));
                    break;
            }
        }
        this.tryTractorBeamStartSlowSpinAttention();
        super.onSpinStepCompleted();
    }

    /**
     * Extended base class function to get random symbol to facilitate condition when only wild is left in reelset.
     * @param reelSet
     */
    protected getRandomSymbolFromReelSet(reelSet:string[]):string {
        // TODO: Something f0rks up after slot-game update!
        let symbol:string;
        do {
            symbol = ArrayHelper.getRandomElementFromArray<string>(reelSet);
        } while(this.isSpecialSymbol(symbol) && (symbol !== ReelSymbolName.WILD));
        //NEED TO ADD FREESPIN CHECK
        return symbol;
        //return super.getRandomSymbolFromReelSet(reelSet);
    }

    private logRandomSymbolPosition(reelId:number):void {
        if(reelId != this._reelId) {
            return;
        }
        let slowDownAttententionSymbols:string[] = this._slowDownAttententionSymbols;
        let slowAttentionSymbols:StateReelSymbol[] = this._reelPartAnimator.symbolsToAnimate.filter(function(element) {
            return (element.currentState!.keyword === "normal" && slowDownAttententionSymbols.indexOf(element.symName) > -1);
        });
        if(slowAttentionSymbols) {
            // TODO: switch out scatters here
            //if(this._reelPartAnimator.symbolsToAnimate[0] && this._reelPartAnimator.symbolsToAnimate[0].symName === "S") {
            //this._reelPartAnimator.symbolsToAnimate[0]
            //}

            this.blurNextReelSymbol(this._reelPartAnimator.symbolsToAnimate[0]);
        }
        if(slowAttentionSymbols && slowAttentionSymbols.length > 0) {
            EventHandler.dispatchEvent(new GameEvent(TractorBeamRandFeatureEvent.ANIMATE_RANDOM_SYMBOL, this.reelId, slowAttentionSymbols));
        }
    }

    /**
     * Extended base class function to handle quickstop scenario for random feature.
     * @param data
     * @param delay
     */
    public stopSpin(data:IReelStopSpinData, delay:number):number {
        this._quickStop = data.quickStop;
        if(!this._randomFeatureTriggered || (this._randomFeatureTriggered && this._slowDownAttententionSymbols.length === 0)) {
            return super.stopSpin(data, delay);
        } else {
            return 0;
        }
    }

    // TODO: Preparation for custom spin times
    protected getStopDelayDelta(stopSpinData:IReelStopSpinData):number {
        if(this._randomStackedTriggered) {
            if(this._randomStackedOverlayReels[this.reelId]) {
                return 0;
            }
        }

        return super.getStopDelayDelta(stopSpinData);
    }
}
